import Price from './price';
import {formatMoney, firstUpper, declension} from 'methods/utils';

function Sutochno(parent, search) {
    Price.call(this, parent, search);
}

Sutochno.prototype = Object.create(Price.prototype);
Object.defineProperty(Sutochno.prototype, 'constructor', {
    value: Sutochno,
    enumerable: false,
    writable: true,
});

Sutochno.prototype.render = function(request) {
    let {
        apartment_list,
        single_apartment,
    } = request;

    for (let apartment_id in apartment_list) {
        const apartment = apartment_list[apartment_id];

        if (single_apartment) {
            return this.renderSingleApartment(apartment);
        }

        let $apartment = this._$roomsBlock.querySelector('.js-apartmentItem[data-id="' + apartment.id + '"]');
        this.renderApartment($apartment, apartment);
    }
}

Sutochno.prototype.renderApartment = function($apartment, apartment) {
    const $price        = $apartment.querySelector('.js-roomPriceTitle');
    const $oldPrice     = $apartment.querySelector('.js-roomPriceTitleOld');
    const $description  = $apartment.querySelector('.js-roomPriceDescription');
    const $errorMessage = $apartment.querySelector('.js-roomPriceNotifcation');
    const $sendButton   = $apartment.querySelector('.js-buttonChange');

    if (apartment.min_price > 0) {
        $price.innerHTML = `<span class="main-price">${this.search.hasDates() ? '' : 'от'} ${formatMoney(apartment.min_price)} руб.</span>`;
    } else {
        $price.innerHTML = '';
    }

    if (apartment.old_price > 0) {
        $oldPrice.textContent = `${this.search.hasDates() ? '' : 'от'} ${formatMoney(apartment.old_price)} руб.`;
    } else {
        $oldPrice.textContent = '';
    }

    $description.textContent = apartment.price_variant_title;

    $apartment.classList.remove('has-error');
    if (apartment.error) {
        $errorMessage.textContent = apartment.error;
        $apartment.classList.add('has-error');
    }

    // хотфикс, тарифы рендерятся с бэка, рендерятся неправильно, нет доступа к тарифам из класса родителя
    // поэтому приходится удалять так
    $apartment.querySelectorAll('.plan-item').forEach($item => {
        $item.classList.toggle('is-hidden', $apartment.classList.contains('has-error'));
    });

    if ($sendButton && apartment.min_price) {
        $sendButton.dataset.apartment_id    = apartment.id;
        $sendButton.dataset.apartment_title = apartment.title;
        $sendButton.dataset.price           = apartment.min_price;
    }
}

// без номеров
Sutochno.prototype.renderSingleApartment = function(apartment) {
    const $totalAmount = document.querySelector('.js-totalAmount');
    const $totalAmountWrapper = document.querySelector('.js-totalAmountWrapper');
    const $totalError = $totalAmount.querySelector('.js-totalError');
    const $sendButton = document.querySelector('.js-contactWrapper .js-buttonChange');

    // показываем цены и ошибки
    $totalAmount.classList.add('is-active');

    if (window.hotelPortal) {
        const portal = window.hotelPortal;

        if (!this.search.hasDates()) {
            portal.reset(apartment.min_price);
        } else {
            const options = {day: 'numeric', month: 'short'};
            const dateArrival = new Date(this.search.getData().date_start).toLocaleString('ru-Ru', options);
            const dateDeparture = new Date(this.search.getData().date_finish).toLocaleString('ru-Ru', options);
            const requestUrl = document.querySelector('.js-mainNav').getAttribute('data-order_url');

            portal.setDates(dateArrival, dateDeparture);
            portal.setText(apartment.price_variant_title);
            portal.setValue(apartment.min_price);
            portal.setButtonData('Оставить заявку', requestUrl);
        }
    }

    const $writeOwnerCashback = document.querySelector('.js-writeOwnerCashback');
    if ($writeOwnerCashback) {
        $writeOwnerCashback.classList.toggle('is-active', false);
    }

    $totalAmount.classList.remove('has-error');
    if (apartment.error) {
        $totalError.innerHTML = apartment.error;
        $totalAmount.classList.add('has-error');

        return;
    }

    const lines = [];
    const nights = this.search.daysCount() || 1;
    const perNight = apartment.min_price / nights;
    const hasDates = this.search.hasDates();

    if (isFinite(perNight)) {
        const pricePrefix = !hasDates ? 'от ' : '';
        
        lines.push(
            `<div class="Write-owner__total-row">
                <div>За сутки</div>
                <div>
                    ${apartment.old_price ?
                        `<div class="hot-price">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.639 13.5541C21.639 18.796 17.3237 23.0454 12.0005 23.0454C6.6773 23.0454 2.362 18.796 2.362 13.5541C2.71226 9.76008 3.8325 12.9778 4.6099 13.5501C4.86728 13.7396 4.97895 13.3112 4.91484 13.0011C4.01816 8.6642 8.27174 5.3861 8.27174 6.9034C8.27174 10.9428 12.7783 5.3466 9.81514 1.8292C9.55215 1.51706 9.7516 0.98764 10.1585 1.05055C14.7005 1.75279 19.8295 5.89675 19.5619 11.2486C19.5478 11.5299 19.5851 11.8492 19.8238 12.0046C20.7889 12.6332 21.4469 9.07808 21.639 13.5541Z" fill="#FF1F6B"/>
                                <path d="M17.136 16.3208C17.136 19.193 14.8367 21.5214 12.0002 21.5214C9.1637 21.5214 6.8643 19.193 6.8643 16.3208C7.05094 14.2419 7.64782 16.005 8.0621 16.3186C8.19924 16.4224 8.25873 16.1877 8.22458 16.0177C7.74678 13.6414 10.0134 11.8452 10.0134 12.6766C10.0134 14.8899 12.4146 11.8236 10.8358 9.89625C10.6956 9.72523 10.8019 9.43518 11.0187 9.46961C13.4389 9.85439 16.1719 12.125 16.0293 15.0576C16.0218 15.2118 16.0417 15.3868 16.1688 15.4719C16.6831 15.8163 17.0337 13.8683 17.136 16.3208Z" fill="#FFE01F"/>
                            </svg>
                            <span>${pricePrefix}${formatMoney(apartment.min_price / nights)} ₽</span>
                        </div>
                        <div class="old-price">
                            ${pricePrefix}${formatMoney(apartment.old_price / nights)} ₽
                        </div>` : `<span class="main-price main-price_mini">${pricePrefix}${formatMoney(apartment.min_price / nights)} ₽</span>`
                    }
                </div>
            </div>`
        );
    }

    if (this.search.hasDates()) {
        lines.push(
            `<div class="Write-owner__total-row">
                <div>${apartment.price_variant_title}</div>
                <div>
                    ${apartment.old_price ?
                        `<div class="hot-price">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.639 13.5541C21.639 18.796 17.3237 23.0454 12.0005 23.0454C6.6773 23.0454 2.362 18.796 2.362 13.5541C2.71226 9.76008 3.8325 12.9778 4.6099 13.5501C4.86728 13.7396 4.97895 13.3112 4.91484 13.0011C4.01816 8.6642 8.27174 5.3861 8.27174 6.9034C8.27174 10.9428 12.7783 5.3466 9.81514 1.8292C9.55215 1.51706 9.7516 0.98764 10.1585 1.05055C14.7005 1.75279 19.8295 5.89675 19.5619 11.2486C19.5478 11.5299 19.5851 11.8492 19.8238 12.0046C20.7889 12.6332 21.4469 9.07808 21.639 13.5541Z" fill="#FF1F6B"/>
                                <path d="M17.136 16.3208C17.136 19.193 14.8367 21.5214 12.0002 21.5214C9.1637 21.5214 6.8643 19.193 6.8643 16.3208C7.05094 14.2419 7.64782 16.005 8.0621 16.3186C8.19924 16.4224 8.25873 16.1877 8.22458 16.0177C7.74678 13.6414 10.0134 11.8452 10.0134 12.6766C10.0134 14.8899 12.4146 11.8236 10.8358 9.89625C10.6956 9.72523 10.8019 9.43518 11.0187 9.46961C13.4389 9.85439 16.1719 12.125 16.0293 15.0576C16.0218 15.2118 16.0417 15.3868 16.1688 15.4719C16.6831 15.8163 17.0337 13.8683 17.136 16.3208Z" fill="#FFE01F"/>
                            </svg>
                            <span>${formatMoney(apartment.min_price)} ₽</span>
                        </div>
                        <div class="old-price">
                            ${formatMoney(apartment.old_price)} ₽
                        </div>` : `<span class="main-price main-price_mini">${formatMoney(apartment.min_price)} ₽</span>`
                    }
                </div>
            </div>`
        );
    }

    $totalAmountWrapper.innerHTML = (
        `<div class="Write-owner__total-title">Итоговая сумма:</div>${lines.join("\n")}`
    );

    if ($writeOwnerCashback) {
        const $writeOwnerCashbackValue = $writeOwnerCashback.querySelector('.js-writeOwnerCashbackValue');
        const $writeOwnerCashbackHint  = $writeOwnerCashback.querySelector('.js-writeOwnerCashbackHint');
        const hasCashback              = apartment.cashback > 0;

        if (hasCashback) {
            $writeOwnerCashbackValue.textContent = `Кэшбэк ${formatMoney(apartment.cashback)} ${declension(apartment.cashback, 'бонус', 'бонуса', 'бонусов')}`;

            const hintContent = `Кэшбэк начисляется бонусами на ваш баланс в личном кабинете Суточно.ру. Вы получите ${formatMoney(apartment.cashback)} бонусов после отзыва о проживании.`;
            $writeOwnerCashbackHint.dataset.hintContent = hintContent;

            if ($writeOwnerCashbackHint.hint) {
                $writeOwnerCashbackHint.hint.setContent(hintContent);
            }
        }

        $writeOwnerCashback.classList.toggle('is-active', hasCashback);
    }

    if ($sendButton && apartment.min_price) {
        $sendButton.dataset.apartment_id    = apartment.id;
        $sendButton.dataset.apartment_title = apartment.title;
        $sendButton.dataset.price           = apartment.min_price;
    }
}

export default Sutochno;
